////////LIBRARY/////////
import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import _, { cloneDeep, reject, isUndefined, isEmpty, map, isEqual, filter } from 'lodash'
///////COMPONENTS///////
import theme from '../../../theme/theme'
import ListSearchable from '../../../components/ListSearchable'
import UseDatePicker from '../../../hooks/UseDatePicker'
import {
	InputLogin,
	SearchInputButton,
	SearchInputWrapper,
	PageGridTitle,
	PageGridBorder,
	SearchReset,
	LabelText,
	SelectInputWrapper,
	SelectInput,
	SelectFlexWrapper,
	ErrorInputMsg,
} from '../../../theme/GlobalCss'
import ToggleFilters from '../../Ui/ToggleFilters'
import RadioContainer from '../Forms/RadioContainer'
import CalendarInputInline from '../../CalendarInputInline'
import { kioskPerimeterActionCreators } from '../../../store/actions'
import Tooltip from '../../Tooltip/Tooltip'
import { useForm } from 'react-hook-form'
import TooltipHelp from '../../TooltipHelp'
/////////ASSETS/////////
import ArrowUp from '../../../assets/icones/global/arrow-up-big.svg'
import ArrowDown from '../../../assets/icones/global/arrow-down-big.svg'
import ArrowUpGrey from '../../../assets/icones/global/arrow-up-big-grey.svg'
import ArrowDownGrey from '../../../assets/icones/global/arrow-down-big-grey.svg'

/////////STYLED/////////
const DynamicWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-column-gap: 20px;
`
const ContentPaper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: repeat(7, max-content);
	grid-row-gap: 20px;
	border-radius: 4px;
	padding: 10px;
	max-height: 595px;
	overflow-y: scroll;
	&::-webkit-scrollbar {
		width: 15px;
		background-color:rgba(0,0,0,.15);
		height: 50px;
	}
	  &::-webkit-scrollbar-thumb {
		  background: #4D4F5C; 
	}
	  &::-webkit-scrollbar-thumb:active {
		background rgba(77, 79, 92, 0.7); 
	}
	  &::-webkit-scrollbar-button:vertical:decrement:single-button {
		  background: no-repeat url(${ArrowUp}) center;
		  height:15px;
	}
	  &::-webkit-scrollbar-button:vertical:increment:single-button {
		  background: no-repeat url(${ArrowDown}) center;
		  height:15px;
	}
	&::-webkit-scrollbar-button:vertical:decrement:single-button:active {
		background: no-repeat url(${ArrowUpGrey}) center;
		height:15px;
  }
	&::-webkit-scrollbar-button:vertical:increment:single-button:active {
		background: no-repeat url(${ArrowDownGrey}) center;
		height:15px;
  }
	  /* scrollbar styling standard version */
	  & {
		scrollbar-color: #4D4F5C #E5E5E5;
		scrollbar-width: thin;
	}
`
const ListActions = styled.div`
	position: relative;
	padding: 10px;
	display: flex;
	flex-direction: row;
	&:nth-child(2) {
		border-bottom: 1px solid ${(props) => props.theme.colors.TabNav.border};
	}
	justify-content: space-between;
`
const TagSearchWrapper = styled.div`
	position: relative;
	& > * > input {
		font-size: ${(props) => props.theme.font.fs};
	}
	display: flex;
	flex-direction: row;
`
const ListEditableRedux = styled.div`
	& > div > div > div {
		margin: 0px;
		border: 0px;
		padding: 10px 23px;
	}
	& > div > div > div > * {
		margin: 0px 7px;
	}
`
const RowsSelectedCounter = styled.span`
	font-weight: bold;
	color: ${(props) => props.theme.colors.primary};
`
const PerimeterCriteriasWrapper = styled.div``
/////////STYLED/////////

const DynamicPerimeter = (props) => {
	const { translations, kioskPerimeter, datePicker, languagesList } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			kioskPerimeter: state.kioskPerimeter,
			datePicker: state.user.datePicker,
			languagesList: state.languages.items,
		}),
		shallowEqual
	)
	const actionsKioskPerimeter = bindActionCreators(kioskPerimeterActionCreators, useDispatch())

	const [inputData, setInputData] = useState([])
	const [sortDir, setSortDir] = useState(1)
	const [searchValue, setSearchValue] = useState('')
	const [searched, setSearched] = useState('')

	const reflistTagsSelected = useRef([])
	const refListTags = useRef()
	const refListCriterias = useRef()

	const [
		installPeriodShowModal,
		installPeriodOpenDateModalHandler,
		installPeriodRenderModal,
		installPeriodStateDate,
		installPeriodSetStartDate,
		installPeriodSetEndDate,
	] = UseDatePicker({ insideModal: true })

	const [
		lastModifPeriodShowModal,
		lastModifPeriodOpenDateModalHandler,
		lastModifPeriodRenderModal,
		lastModifPeriodStateDate,
		lastModifPeriodStartDate,
		lastModifPeriodEndDate,
	] = UseDatePicker({ insideModal: true })

	const [
		lastActivPeriodShowModal,
		lastActivPeriodOpenDateModalHandler,
		lastActivPeriodRenderModal,
		lastActivPeriodStateDate,
		lastActivPeriodStartDate,
		lastActivPeriodEndDate,
	] = UseDatePicker({ insideModal: true })

	const [currentInstallPeriodStateDate, setCurrentInstallPeriodStateDate] = useState(installPeriodStateDate)
	const [currentLastModifPeriodStateDate, setCurrentLastModifPeriodStateDate] = useState(lastModifPeriodStateDate)
	const [currentLastActivPeriodStateDate, setCurrentLastActivPeriodStateDate] = useState(lastActivPeriodStateDate)

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		nameTags: translations['page__scopeManagement__dynamic_tag_selection'],
		nameCriterias: translations['page__scopeManagement__dynamic_criterion_selection'],
		radiosPayment: {
			title: `${translations['page__scopeManagement__dynamic_criterion_code']} :`,
			name: 'paymentByCode',
			list: [
				{ id: 0, value: true, label: translations['common__text__yes'] },
				{ id: 1, value: false, label: translations['common__text__no'] },
				{ id: 2, value: null, label: translations['common__text__all'] },
			],
		},
		radiosState: {
			title: `${translations['page__scopeManagement__dynamic_criterion_kiosk_state']} :`,
			name: 'isDisabled',
			list: [
				{ id: 0, value: true, label: translations['page__scopeManagement__dynamic_criterion_kiosk_active'] },
				{ id: 1, value: false, label: translations['page__scopeManagement__dynamic_criterion_kiosk_inactive'] },
				{ id: 2, value: null, label: translations['page__scopeManagement__dynamic_criterion_kiosk_all'] },
			],
		},
		radiosSolarPanel: {
			title: `${translations['page__scopeManagement__dynamic_criterion_solarPanel']} :`,
			name: 'solarPanel',
			list: [
				{ id: 0, value: true, label: translations['common__text__yes'] },
				{ id: 1, value: false, label: translations['common__text__no'] },
				{ id: 2, value: null, label: translations['common__text__all'] },
			],
		},
		radiosScale: {
			title: `${translations['page__scopeManagement__dynamic_criterion_scale']} :`,
			name: 'scale',
			list: [
				{ id: 0, value: true, label: translations['common__text__yes'] },
				{ id: 1, value: false, label: translations['common__text__no'] },
				{ id: 2, value: null, label: translations['common__text__all'] },
			],
		},
		radiosBottleDetection: {
			title: `${translations['page__scopeManagement__dynamic_criterion_bottleDetection']} :`,
			name: 'bottleDetection',
			list: [
				{ id: 0, value: true, label: translations['common__text__yes'] },
				{ id: 1, value: false, label: translations['common__text__no'] },
				{ id: 2, value: null, label: translations['common__text__all'] },
			],
		},
		filters: {
			searchValue: searched,
		},
		operators: [
			{ id: 0, value: 'equal', label: '=' },
			{ id: 1, value: 'less', label: '<' },
			{ id: 2, value: 'more', label: '>' },
		],
		noStandardFilters: true,
	}

	const [stateDefaultValues, setStateDefaultValues] = useState({
		paymentByCode: config.radiosPayment.list[2].id.toString(),
		isDisabled: config.radiosState.list[2].id.toString(),
		solarPanel: config.radiosState.list[2].id.toString(),
		scale: config.radiosState.list[2].id.toString(),
		bottleDetection: config.radiosState.list[2].id.toString(),

		label: null,
		ipAddress: null,
		lockersNumber: null,
		operator: config.operators[0].value,
		model: null,
		appVersion: '',
		idLanguage: 2,
	})

	const columns = [
		// We set what data value is used to
		// For setting value of input
		{ isCheckboxValue: true, dataHook: 'id', headerName: 'id', sortable: false },
		// For labelling the item
		{ isLabel: true, dataHook: 'name', headerName: 'name', sortable: true, alreadyTranslated: true },
	]

	const { register, handleSubmit, errors, setValue, getValues, reset } = useForm({
		defaultValues: stateDefaultValues,
	})

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleInputData = () => {
		let newinputData = cloneDeep(kioskPerimeter.kioskPerimeterDetail.tags)
		if (searchValue.length > 0) {
			newinputData = reject(newinputData, (o) => {
				let str = cloneDeep(o.name)
				str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
				let transformed_search = cloneDeep(searchValue)
				transformed_search = transformed_search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
				return str.toUpperCase().includes(transformed_search.toUpperCase()) ? false : true
			})
		}
		setInputData(newinputData)
	}

	const handleSearchValue = (e) => {
		setSearchValue(e.target.value)
	}

	const handleSearch = (_e) => {
		setSearched(searchValue)
	}

	const handleSearchEnter = (e) => {
		if (e.keyCode === 13 || searchValue === '') setSearched(searchValue)
	}

	const onSubmit = (data) => {
		let datas = {}
		datas.criterionsSelection = cloneDeep(data)
		// Adjusting operators
		if (isEmpty(datas.criterionsSelection.operator) || isEmpty(datas.criterionsSelection.lockersNumber)) {
			datas.criterionsSelection.operator = null
			datas.criterionsSelection.lockersNumber = null
		}
		// Adding dates
		if (!isEmpty(currentInstallPeriodStateDate.date)) {
			datas.criterionsSelection.installationDateStart = currentInstallPeriodStateDate.date.startDate
			datas.criterionsSelection.installationDateEnd = currentInstallPeriodStateDate.date.endDate
		}
		if (!isEmpty(currentLastModifPeriodStateDate.date)) {
			datas.criterionsSelection.lastUpdateDateStart = currentLastModifPeriodStateDate.date.startDate
			datas.criterionsSelection.lastUpdateDateEnd = currentLastModifPeriodStateDate.date.endDate
		}
		if (!isEmpty(currentLastActivPeriodStateDate.date)) {
			datas.criterionsSelection.lastActivationDateStart = currentLastActivPeriodStateDate.date.startDate
			datas.criterionsSelection.lastActivationDateEnd = currentLastActivPeriodStateDate.date.endDate
		}
		// Handling radios
		switch (datas.criterionsSelection.paymentByCode) {
			case '0':
				datas.criterionsSelection.paymentByCode = true
				break
			case '1':
				datas.criterionsSelection.paymentByCode = false
				break
			default:
				datas.criterionsSelection.paymentByCode = null
				break
		}
		switch (datas.criterionsSelection.isDisabled) {
			case '0':
				datas.criterionsSelection.isDisabled = true
				break
			case '1':
				datas.criterionsSelection.isDisabled = false
				break
			default:
				datas.criterionsSelection.isDisabled = null
				break
		}
		switch (datas.criterionsSelection.solarPanel) {
			case '0':
				datas.criterionsSelection.solarPanel = true
				break
			case '1':
				datas.criterionsSelection.solarPanel = false
				break
			default:
				datas.criterionsSelection.solarPanel = null
				break
		}
		switch (datas.criterionsSelection.scale) {
			case '0':
				datas.criterionsSelection.scale = true
				break
			case '1':
				datas.criterionsSelection.scale = false
				break
			default:
				datas.criterionsSelection.scale = null
				break
		}
		switch (datas.criterionsSelection.bottleDetection) {
			case '0':
				datas.criterionsSelection.bottleDetection = true
				break
			case '1':
				datas.criterionsSelection.bottleDetection = false
				break
			default:
				datas.criterionsSelection.bottleDetection = null
				break
		}
		datas.tags = props.listTagSelected

		datas.criterionsSelection.model = datas.criterionsSelection.model.length > 0 ? datas.criterionsSelection.model : null
		datas.criterionsSelection.label = datas.criterionsSelection.label.length > 0 ? datas.criterionsSelection.label : null
		datas.criterionsSelection.ipAddress = datas.criterionsSelection.ipAddress.length > 0 ? datas.criterionsSelection.ipAddress : null
		datas.criterionsSelection.appVersion = datas.criterionsSelection.appVersion.length > 0 ? datas.criterionsSelection.appVersion : null

		props.setCriterions(datas)

		actionsKioskPerimeter.getKiosksWithCriteria(datas, 'dynamic')
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		// Whenever we change filters we redraw the list
		handleInputData()
	}, [searched])

	useEffect(() => {
		// When tag list has changed
		if (!isUndefined(kioskPerimeter.kioskPerimeterDetail.tags) && !isEqual(refListTags.current, kioskPerimeter.kioskPerimeterDetail.tags))
			setInputData(kioskPerimeter.kioskPerimeterDetail.tags)
		refListTags.current = kioskPerimeter.kioskPerimeterDetail.tags
	}, [kioskPerimeter.kioskPerimeterDetail.tags])

	// Setup default dates shown
	// Or maybe we could set them to null ?
	useEffect(() => {
		let inst_period = cloneDeep(installPeriodStateDate)
		inst_period.date.startDate = null
		inst_period.date.endDate = null
		setCurrentInstallPeriodStateDate(inst_period)

		let modif_period = cloneDeep(lastModifPeriodStateDate)
		modif_period.date.startDate = null
		modif_period.date.endDate = null
		setCurrentLastModifPeriodStateDate(modif_period)

		let activ_period = cloneDeep(lastActivPeriodStateDate)
		activ_period.date.startDate = null
		activ_period.date.endDate = null
		setCurrentLastActivPeriodStateDate(activ_period)
	}, [datePicker])

	// Everytime the modal is closed, we update the value
	// This to trigger update kiosk list only on closing modal
	useEffect(() => {
		if (installPeriodStateDate.showModal) {
			setCurrentInstallPeriodStateDate(installPeriodStateDate)
			onSubmit(getValues())
		}
	}, [installPeriodShowModal])

	useEffect(() => {
		if (lastModifPeriodStateDate.showModal) {
			setCurrentLastModifPeriodStateDate(lastModifPeriodStateDate)
			onSubmit(getValues())
		}
	}, [lastModifPeriodShowModal])

	useEffect(() => {
		if (lastActivPeriodStateDate.showModal) {
			setCurrentLastActivPeriodStateDate(lastActivPeriodStateDate)
			onSubmit(getValues())
		}
	}, [lastActivPeriodShowModal])

	// Loading tags
	useEffect(() => {
		// We only load tag list once. If we are switching perimter, no need to reload again
		actionsKioskPerimeter.getListTags()
		// On load, we reset the referential of selected tag
		// This prevent submitting after reswitching from static mode
		if (!isEmpty(reflistTagsSelected.current)) reflistTagsSelected.current = []
	}, [])

	useEffect(() => {
		// When selected tag list change, we submit a back call
		if (!isEqual(props.listTagSelected, reflistTagsSelected.current)) {
			onSubmit(getValues())
		}
		reflistTagsSelected.current = props.listTagSelected
	}, [props.listTagSelected])

	useEffect(() => {
		// Loading criterias from get perimeter call
		if (
			!isEqual(refListCriterias.current, kioskPerimeter.kioskPerimeterDetail.criterionsSelection) &&
			kioskPerimeter.kioskPerimeterDetail.criterionsSelection !== false &&
			kioskPerimeter.kioskPerimeterDetail.criterionsSelection !== null &&
			!isUndefined(kioskPerimeter.kioskPerimeterDetail.criterionsSelection) &&
			kioskPerimeter.kioskPerimeterDetail !== false
		) {
			let obj = {}

			obj = filter(config.radiosPayment.list, { value: kioskPerimeter.kioskPerimeterDetail.criterionsSelection.paymentByCode })[0].id
			setValue('paymentByCode', obj.toString())

			obj = filter(config.radiosState.list, { value: kioskPerimeter.kioskPerimeterDetail.criterionsSelection.isDisabled })[0].id
			setValue('isDisabled', obj.toString())

			obj = filter(config.radiosSolarPanel.list, { value: kioskPerimeter.kioskPerimeterDetail.criterionsSelection.solarPanel })[0].id
			setValue('solarPanel', obj.toString())

			obj = filter(config.radiosScale.list, { value: kioskPerimeter.kioskPerimeterDetail.criterionsSelection.scale })[0].id
			setValue('scale', obj.toString())

			obj = filter(config.radiosBottleDetection.list, { value: kioskPerimeter.kioskPerimeterDetail.criterionsSelection.bottleDetection })[0].id
			setValue('bottleDetection', obj.toString())

			setValue('label', kioskPerimeter.kioskPerimeterDetail.criterionsSelection.label)
			setValue('ipAddress', kioskPerimeter.kioskPerimeterDetail.criterionsSelection.ipAddress)
			setValue('lockersNumber', kioskPerimeter.kioskPerimeterDetail.criterionsSelection.lockersNumber)

			// We can have case where obj is null, and so cannot be assigned to select
			obj = filter(config.operators, { label: kioskPerimeter.kioskPerimeterDetail.criterionsSelection.operator })
			if (!isEmpty(obj)) {
				obj = obj[0].value
				setValue('operator', obj)
			}

			setValue('model', kioskPerimeter.kioskPerimeterDetail.criterionsSelection.model)
			setValue('appVersion', kioskPerimeter.kioskPerimeterDetail.criterionsSelection.appVersion)
			setValue('idLanguage', kioskPerimeter.kioskPerimeterDetail.criterionsSelection.idLanguage)

			setStateDefaultValues(getValues)

			// Handling of dates => not in register
			if (kioskPerimeter.kioskPerimeterDetail.criterionsSelection.installationDateStart !== null) {
				let cur_install = cloneDeep(currentInstallPeriodStateDate)
				cur_install.date.startDate = moment(kioskPerimeter.kioskPerimeterDetail.criterionsSelection.installationDateStart)
				cur_install.date.endDate = moment(kioskPerimeter.kioskPerimeterDetail.criterionsSelection.installationDateEnd)
				setCurrentInstallPeriodStateDate(cur_install)
			}

			if (kioskPerimeter.kioskPerimeterDetail.criterionsSelection.lastActivationDateStart !== null) {
				let cur_install = cloneDeep(currentLastActivPeriodStateDate)
				cur_install.date.startDate = moment(kioskPerimeter.kioskPerimeterDetail.criterionsSelection.lastActivationDateStart)
				cur_install.date.endDate = moment(kioskPerimeter.kioskPerimeterDetail.criterionsSelection.lastActivationDateEnd)
				setCurrentLastActivPeriodStateDate(cur_install)
			}

			if (kioskPerimeter.kioskPerimeterDetail.criterionsSelection.lastUpdateDateStart !== null) {
				let cur_install = cloneDeep(currentLastModifPeriodStateDate)
				cur_install.date.startDate = moment(kioskPerimeter.kioskPerimeterDetail.criterionsSelection.lastUpdateDateStart)
				cur_install.date.endDate = moment(kioskPerimeter.kioskPerimeterDetail.criterionsSelection.lastUpdateDateEnd)
				setCurrentLastModifPeriodStateDate(cur_install)
			}
		}

		refListCriterias.current = kioskPerimeter.kioskPerimeterDetail.criterionsSelection
	}, [kioskPerimeter.kioskPerimeterDetail.criterionsSelection])

	// reset form when raz
	useEffect(() => {
		reset(stateDefaultValues)
		let inst_period = cloneDeep(installPeriodStateDate)
		inst_period.date.startDate = null
		inst_period.date.endDate = null
		installPeriodSetStartDate(moment().subtract(2, 'weeks').toDate())
		installPeriodSetEndDate(moment().toDate())
		setCurrentInstallPeriodStateDate(inst_period)

		let modif_period = cloneDeep(lastModifPeriodStateDate)
		modif_period.date.startDate = null
		modif_period.date.endDate = null
		lastModifPeriodStartDate(moment().subtract(2, 'weeks').toDate())
		lastModifPeriodEndDate(moment().toDate())
		setCurrentLastModifPeriodStateDate(modif_period)

		let activ_period = cloneDeep(lastActivPeriodStateDate)
		activ_period.date.startDate = null
		activ_period.date.endDate = null
		lastActivPeriodStartDate(moment().subtract(2, 'weeks').toDate())
		lastActivPeriodEndDate(moment().toDate())
		setCurrentLastActivPeriodStateDate(activ_period)
	}, [props.resetDefValues])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<DynamicWrapper ref={refListTags}>
			{installPeriodRenderModal()}
			{lastModifPeriodRenderModal()}
			{lastActivPeriodRenderModal()}
			<div>
				<TooltipHelp content={'tooltipHelp__admin__modal__body__scopeManagement__selectTag'} insideModal>
					<PageGridTitle>{config.nameTags}</PageGridTitle>
				</TooltipHelp>
				<PageGridBorder>
					<ListActions>
						<TagSearchWrapper>
							<SearchInputWrapper>
								<InputLogin
									value={searchValue}
									onChange={handleSearchValue}
									onKeyDown={handleSearchEnter}
									placeholder={translations['page__tagManagement__tag_search']}
								/>
								<SearchInputButton onClick={handleSearch} />
							</SearchInputWrapper>
							{searchValue.length > 0 && (
								<SearchReset
									onClick={() => {
										setSearchValue('')
										setSearched('')
									}}
								/>
							)}
						</TagSearchWrapper>
					</ListActions>
					<ListActions>
						<Tooltip
							tooltipId={'scopeKioskSortTags'}
							translationsKey={'tooltip__admin__scopeManagement__filter__sort_tag'}
							position={'right'}
						>
							<ToggleFilters
								checked={sortDir}
								onChangeHandler={() => {
									setSortDir(sortDir === 0 ? 1 : 0)
								}}
								name="columnSort"
								labelPrev="AZ"
								labelNext="ZA"
								reverseCheck
							/>
						</Tooltip>
						<div>
							<RowsSelectedCounter>{!isUndefined(props.listTagSelected) ? props.listTagSelected.length : 0}</RowsSelectedCounter>{' '}
							{translations['page__scopeManagement__dynamic_tag_selected']}
						</div>
					</ListActions>
					<ListEditableRedux>
						<ListSearchable
							inputData={inputData}
							inputColumns={columns}
							inputConfig={config}
							type="checkbox"
							translationMode={true}
							sortColumnName={'name'}
							sortDir={sortDir}
							hookList={props.setListTagSelected}
							sizeHeightActions={230}
							ref={reflistTagsSelected}
							summaryList={props.listTagSelected}
							fixedBaseHeight={750} // In fact height of modal
						/>
					</ListEditableRedux>
				</PageGridBorder>
			</div>
			<PerimeterCriteriasWrapper ref={refListCriterias}>
				<form>
					<TooltipHelp content={'tooltipHelp__admin__modal__body__scopeManagement__selectCriterion'} insideModal>
						<PageGridTitle>{config.nameCriterias}</PageGridTitle>
					</TooltipHelp>
					<PageGridBorder>
						<ContentPaper>
							<div>
								<LabelText style={{ color: theme.colors.tabText, marginBottom: '10px' }}>
									{translations['page__scopeManagement__dynamic_criterion_label']} :
								</LabelText>
								<InputLogin name="label" ref={register()} onChange={_.debounce(handleSubmit(onSubmit), 250)} />
							</div>
							{
								<RadioContainer
									register={register}
									name={config.radiosPayment.name}
									title={config.radiosPayment.title}
									list={config.radiosPayment.list}
									handleSubmit={handleSubmit(onSubmit)}
								/>
							}
							{
								<RadioContainer
									register={register}
									name={config.radiosState.name}
									title={config.radiosState.title}
									list={config.radiosState.list}
									handleSubmit={handleSubmit(onSubmit)}
								/>
							}
							{
								<RadioContainer
									register={register}
									name={config.radiosSolarPanel.name}
									title={config.radiosSolarPanel.title}
									list={config.radiosSolarPanel.list}
									handleSubmit={handleSubmit(onSubmit)}
								/>
							}
							{
								<RadioContainer
									register={register}
									name={config.radiosScale.name}
									title={config.radiosScale.title}
									list={config.radiosScale.list}
									handleSubmit={handleSubmit(onSubmit)}
								/>
							}
							{
								<RadioContainer
									register={register}
									name={config.radiosBottleDetection.name}
									title={config.radiosBottleDetection.title}
									list={config.radiosBottleDetection.list}
									handleSubmit={handleSubmit(onSubmit)}
								/>
							}
							<div>
								<LabelText style={{ color: theme.colors.tabText, marginTop: '10px' }}>
									{translations['page__scopeManagement__dynamic_criterion_date_installation']} :
								</LabelText>
								<CalendarInputInline
									onClickHandler={installPeriodOpenDateModalHandler}
									valueInput={
										currentInstallPeriodStateDate.date.startDate !== null && currentInstallPeriodStateDate.date.endDate !== null
											? `${moment(currentInstallPeriodStateDate.date.startDate).format('DD-MM-YYYY')} - ${moment(
													currentInstallPeriodStateDate.date.endDate
											  ).format('DD-MM-YYYY')}`
											: ''
									}
								/>
							</div>
							<div>
								<LabelText style={{ color: theme.colors.tabText, marginTop: '10px' }}>
									{translations['page__scopeManagement__dynamic_criterion_date_modification']} :
								</LabelText>
								<CalendarInputInline
									onClickHandler={lastModifPeriodOpenDateModalHandler}
									valueInput={
										currentLastModifPeriodStateDate.date.startDate !== null &&
										currentLastModifPeriodStateDate.date.endDate !== null
											? `${moment(currentLastModifPeriodStateDate.date.startDate).format('DD-MM-YYYY')} - ${moment(
													currentLastModifPeriodStateDate.date.endDate
											  ).format('DD-MM-YYYY')}`
											: ''
									}
								/>
							</div>
							<div>
								<LabelText style={{ color: theme.colors.tabText, marginTop: '10px' }}>
									{translations['page__scopeManagement__dynamic_criterion_date_activation']} :
								</LabelText>
								<CalendarInputInline
									onClickHandler={lastActivPeriodOpenDateModalHandler}
									valueInput={
										currentLastActivPeriodStateDate.date.startDate !== null &&
										currentLastActivPeriodStateDate.date.endDate !== null
											? `${moment(currentLastActivPeriodStateDate.date.startDate).format('DD-MM-YYYY')} - ${moment(
													currentLastActivPeriodStateDate.date.endDate
											  ).format('DD-MM-YYYY')}`
											: ''
									}
								/>
							</div>
							<div>
								<LabelText style={{ color: theme.colors.tabText, marginBottom: '10px' }}>
									{translations['page__scopeManagement__dynamic_criterion_ip']} :
								</LabelText>
								<InputLogin
									name="ipAddress"
									ref={
										register(/*{
									pattern:{
										value:RegExp(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/)  ,
										message: translations['common__text__invalidEmail']
									}
								}*/)
									}
									onChange={_.debounce(handleSubmit(onSubmit), 250)}
								/>
								{errors.ipAddress && <ErrorInputMsg>{errors.ipAddress.message}</ErrorInputMsg>}
							</div>
							<div>
								<LabelText style={{ color: theme.colors.tabText, marginBottom: '10px' }}>
									{translations['page__scopeManagement__dynamic_criterion_rackNumber']} :
								</LabelText>
								<SelectFlexWrapper>
									<SelectInputWrapper reverseMode eraserColor>
										<SelectInput name="operator" reverseMode ref={register()} onChange={handleSubmit(onSubmit)}>
											{map(config.operators, (elem, id) => {
												return (
													<option key={id} value={elem.value}>
														{elem.label}
													</option>
												)
											})}
										</SelectInput>
									</SelectInputWrapper>
									<InputLogin
										style={{ width: '59px', marginLeft: '8px' }}
										name="lockersNumber"
										ref={register({
											pattern: {
												value: RegExp(/^[0-9]*$/),
												message: translations['common__text__invalidEmail'],
											},
										})}
										onChange={handleSubmit(onSubmit)}
									/>
									{errors.lockersNumber && <ErrorInputMsg>{errors.lockersNumber.message}</ErrorInputMsg>}
								</SelectFlexWrapper>
							</div>
							<div>
								<LabelText style={{ color: theme.colors.tabText, marginBottom: '10px' }}>
									{translations['page__scopeManagement__dynamic_criterion_model']} :
								</LabelText>
								<InputLogin name="model" ref={register()} onChange={_.debounce(handleSubmit(onSubmit), 250)} />
							</div>
							<div>
								<LabelText style={{ color: theme.colors.tabText, marginBottom: '10px' }}>
									{translations['page__scopeManagement__dynamic_criterion_version']} :
								</LabelText>
								<InputLogin name="appVersion" ref={register()} onChange={_.debounce(handleSubmit(onSubmit), 250)} />
							</div>
							<div style={{ paddingBottom: '15px' }}>
								<LabelText style={{ color: theme.colors.tabText, marginBottom: '10px' }}>
									{translations['page__scopeManagement__dynamic_criterion_language']} :
								</LabelText>
								<SelectFlexWrapper>
									<SelectInputWrapper eraserColor>
										<SelectInput name="idLanguage" ref={register()} onChange={handleSubmit(onSubmit)}>
											{map(languagesList, (elem, id) => {
												return (
													<option key={id} value={elem?.id}>
														{elem?.labelEnglish}
													</option>
												)
											})}
										</SelectInput>
									</SelectInputWrapper>
								</SelectFlexWrapper>
							</div>
						</ContentPaper>
					</PageGridBorder>
				</form>
			</PerimeterCriteriasWrapper>
		</DynamicWrapper>
	)
}

DynamicPerimeter.propTypes = {}

DynamicPerimeter.defaultPropTypes = {}

export default DynamicPerimeter
